import React from "react";
import JobHistoryUploadComponent from "../../components/Jobs/JobHistoryUploadComponent";

const JobHistoryUpload: React.FC = () => {
  return <JobHistoryUploadComponent />;
};

export default JobHistoryUpload;
